import { useQuery } from "@tanstack/react-query";
import { SearchableEntity } from "../services/searchService";
import searchService from "../services/searchService";

export const useSearchQuery = (
  entity: SearchableEntity,
  searchTerm: string,
  filters?: any
) => {
  return useQuery({
    queryKey: ["search", entity, searchTerm, filters],
    queryFn: async ({ signal }) => {
      return new Promise<any[]>((resolve, reject) => {
        const timeout = setTimeout(() => {
          reject(new Error("Search timeout"));
        }, 10000); // 10 second timeout

        searchService.search(
          entity,
          searchTerm,
          (results) => {
            clearTimeout(timeout);
            resolve(results);
          },
          (error) => {
            clearTimeout(timeout);
            reject(error);
          },
          () => {}, // Loading handled by React Query,
          filters,
        );

        // Cleanup on abort
        signal?.addEventListener("abort", () => {
          clearTimeout(timeout);
          reject(new Error("Search aborted"));
        });
      });
    },
    enabled: true,
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 30, // 30 minutes
    retry: 1, // Only retry once
    retryDelay: 1000, // Wait 1 second before retrying
  });
};
